/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */
// import {
//  Input
// } from 'shared/components/ui/input';
// import {
//  Label
// } from 'shared/components/ui/label';
// import {
//  Table, TableBody, TableHead, TableRow, TableCell
// } from 'shared/components/ui/table';
// import {
//  CardContent, Card
// } from 'shared/components/ui/card';
import {
 useContext, useState
} from 'react';
// import {
//  Button
// } from 'shared/components/ui/button';
import PageSettingsModal from './components/PageSettingsModal';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
// import {
//  Form
// } from 'shared/components/ui/form';
import {
 Context
} from 'shared/context/GlobalState';
import {
 tableTemplateService
} from 'shared/api/services/FEO/template.service';
import {
 useParams
} from 'react-router-dom';
// import {
//  useForm
// } from 'react-hook-form';

interface OpCode {
  id: string;
  name: string;
  description: string;
  dataType: string;
  config: TemplateConfig;
  style: {
    color: string;
    size: string;
    font: string;
  };
  databaseSchema: {
    tables: any;
  };
}

interface Page {
  id: string;
  title: string;
  slug: string;
  layout: string;
  isHomePage: boolean;
  status: boolean;
  pageTitle: string;
  pageCssClass: string;
  visibility: 'public' | 'private' | 'password-protected';
}

interface TemplateConfig {
  selectedMainTable: string | null;
  selectedFields: string[];
  selectedConnectedTables: string[];
  selectedConnectedFields: string[];
  fieldSettings: Record<string, string>;
}

interface Item {
  id: string;
  name?: string;
  dataType?: string;
  title?: string;
  config?: TemplateConfig;
}

export default function ProjectPage() {
  const [activeBuilder, setActiveBuilder] = useState<'opcode' | 'page'>('opcode');
  const [selectedItem, setSelectedItem] = useState<Item >(null);
  const [assistantResponse, setAssistantResponse] = useState<string | null>(null);
  const [jsonBlocks, setJsonBlocks] = useState<any[]>([]);
  const [previewBlocks, setPreviewBlocks] = useState<any | null>(null);
  const [showValidationErrors, setShowValidationErrors] = useState<boolean>(false);
  const {
 oragID, appId
} = useParams<{ oragID: string; appId: string }>();
//  const formMethods = useForm();

  const [opCodes, setOpCodes] = useState<OpCode[]>([
    {
      id: '1',
      name: 'User Table',
      description: 'Displays user information in a table format',
      dataType: 'table',
      config: {
        selectedMainTable: null,
        selectedFields: [],
        selectedConnectedTables: [],
        selectedConnectedFields: [],
        fieldSettings: {}
      },
      style: {
 color: 'primary',
size: 'base',
font: 'sans'
},
      databaseSchema: {
 tables: {}
},
    },
  ]);

  const [pages, setPages] = useState<Page[]>([
    {
      id: '1',
      title: 'Home Page',
      slug: 'home',
      layout: 'Default Layout',
      isHomePage: true,
      status: true,
      pageTitle: 'Welcome to Our Site',
      pageCssClass: '',
      visibility: 'public',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [showPageSettingsModal, setShowPageSettingsModal] = useState<boolean>(false);
  const [newPage, setNewPage] = useState<Page | null>(null);
  // const [message,setMessages] = useState<any[]>([
  //   {
  //     id: '1',
  //     role: 'assistant',
  //     content: "Hello! I'm your OpCode assistant. Describe the component you want to build, and I'll help you create it.",
  //   },
  // ]);

  // const [input, setInput] = useState<string>('');
  // const [selectedConnectedTables, setSelectedConnectedTables] = useState<string[]>(['Users']);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const {
 addNewNotifcation
} = useContext(Context);

  // --------------------- Generate Preview ---------------------
  const generatePreviewPayload = (config: TemplateConfig, schema: any, name: string) => {
    if (!schema?.tables) return null;

    const getSize = () => 6;

    const buildField = (table: string, fieldName: string) => {
      const field = schema.tables?.[table]?.fields?.find((f: any) => f.name === fieldName);
      if (!field) return null;
      const fieldConfig = config.fieldSettings?.[`${table}.${fieldName}`] || 'visible';
      return {
        field: field.name,
        dataType: field.dataType || 'string',
        comparisonOperator: 'contains',
        inputType: 'text',
        label: field.label || field.name,
        placeholder: `Enter ${field.name}`,
        width: '100%',
        size: getSize(),
        visible: fieldConfig === 'visible',
        foreignTable: field.foreignTable || null,
        foreignField: field.foreignField || null,
      };
    };

    const getFields = (tables: string[], fields: string[]) =>
      tables.flatMap((table) =>
        fields
          .filter((f) => f.startsWith(`${table}.`))
          .map((f) => {
            const fieldName = f.split('.')[1];
            const fieldObj = buildField(table, fieldName);
            if (!fieldObj) return null;
            if (table !== config.selectedMainTable) {
              fieldObj.foreignTable = table;
              fieldObj.foreignField = fieldObj.field;
            }
            return fieldObj;
          })
      ).filter(Boolean);

    const allTables = [config.selectedMainTable, ...(config.selectedConnectedTables || [])].filter(Boolean) as string[];
    const allSearchFields = getFields(allTables, [...(config.selectedFields || []), ...(config.selectedConnectedFields || [])]);
    const allTableCols = allSearchFields.map((f: any) => ({
      field: f.field,
      dataType: f.dataType,
      title: f.label || f.field,
      size: 'auto',
    }));

    return {
      templateName: name,
      template: {
        templateName: name,
        tableName: config.selectedMainTable,
        searchComponent: {
 logicalOperator: 'AND',
fields: allSearchFields
},
        tableComponent: {
          tableCol: allTableCols,
          resultDisplayOrder: 'row',
          maxRowsPerPage: 20,
        },
        viewDetailComponent: {
 fields: allSearchFields
},
      },
    };
  };

  // --------------------- Handle Save ---------------------
  const handleSaveChanges = () => {
    if (!selectedItem) return;
    if ('dataType' in selectedItem) {
      setOpCodes((prev) => prev.map((op) => (op.id === selectedItem.id ? selectedItem as OpCode : op)));
    } else {
      setPages((prev) => prev.map((p) => (p.id === selectedItem.id ? selectedItem as Page : p)));
    }
  };

  const handleSaveSchema = async () => {
    if (!selectedItem) return;
    const {
  selectedFields = [], selectedConnectedFields = [], fieldSettings = {}
} = selectedItem.config;
    const allSelectedFields = [...selectedFields, ...selectedConnectedFields];
    const invalidFields = allSelectedFields.filter((fieldName) => !['visible', 'hidden', 'readonly'].includes(fieldSettings?.[fieldName]));
    if (invalidFields.length > 0) {
      setShowValidationErrors(true);
      addNewNotifcation('Please set visibility for all selected fields before saving the schema.', 'warning');
      return;
    }
    setShowValidationErrors(false);

    try {
      setIsSaving(true);
      const generatedTemplate = previewBlocks;
      if (!generatedTemplate) {
        addNewNotifcation('No preview available to save. Please check your template setup.', 'warning');
        return;
      }
      const savePayload = {
 templateName: generatedTemplate.templateName,
template: generatedTemplate
};
      await tableTemplateService.saveSchemaTemplate(oragID, appId, savePayload);

      addNewNotifcation('Schema saved successfully!', 'success');
    } catch (error) {
      console.error('Error saving schema:', error);
      addNewNotifcation('Error saving schema.', 'danger');
    } finally {
      setIsSaving(false);
    }
  };

  // --------------------- Page Handlers ---------------------
  const handleAddPage = () => {
    const pageTemplate: Page = {
      id: Date.now().toString(),
      title: 'New Page',
      slug: 'new-page',
      layout: 'Default Layout',
      isHomePage: false,
      status: true,
      pageTitle: 'New Page',
      pageCssClass: '',
      visibility: 'public',
    };
    setNewPage(pageTemplate);
    setShowPageSettingsModal(true);
  };

  const handleEditPage = (page: Page) => {
    setNewPage(page);
    setShowPageSettingsModal(true);
  };

  // --------------------- OpCode Handlers ---------------------
  const handleAddOpCode = () => {
    const newOpCode: OpCode = {
      id: Date.now().toString(),
      name: 'New OpCode',
      description: 'A new OpCode',
      dataType: 'custom',
      config: {
        selectedMainTable: null,
        selectedFields: [],
        selectedConnectedTables: [],
        selectedConnectedFields: [],
        fieldSettings: {}
      },
      style: {
 color: 'primary',
size: 'base',
font: 'sans'
},
      databaseSchema: {
 tables: {}
},
    };
    setOpCodes((prev) => [...prev, newOpCode]);
    setSelectedItem(newOpCode);
  };

  // --------------------- Chatbot ---------------------
//   const handleSend = () => {
//     if (!input.trim()) return;
//     const newMessage = {
//  id: Date.now().toString(),
// role: 'user',
// content: input
// };
//     setMessages((prev) => [...prev, newMessage]);
//     setInput('');
//     setTimeout(() => {
//       const assistantMessage = {
//         id: (Date.now() + 1).toString(),
//         role: 'assistant',
//         content: "I've created a table component based on your description. You can view and edit it in the configuration panel. Would you like to add any specific details, styling, or database fields?",
//       };
//       setMessages((prev) => [...prev, assistantMessage]);
//     }, 1000);
//   };

  // --------------------- Table & Field Selection ---------------------
//   const handleMainTableChange = (tableName: string) => {
//     if (!selectedItem) return;
//     setSelectedItem({
//       ...selectedItem,
//       config: {
//  ...selectedItem.config,
// selectedMainTable: tableName,
// selectedFields: [],
// selectedConnectedTables: [],
// selectedConnectedFields: []
// },
//     });
//     setSelectedConnectedTables([]);
//   };

  // const handleConnectedTableChange = (tableName: string) => {
  //   if (!selectedItem) return;
  //   const updatedTables = selectedConnectedTables.includes(tableName)
  //     ? selectedConnectedTables.filter((t) => t !== tableName)
  //     : [...selectedConnectedTables, tableName];
  //   setSelectedConnectedTables(updatedTables);
  //   setSelectedItem({
  //     ...selectedItem,
  //     config: {
  //       ...selectedItem.config,
  //       selectedConnectedTables: updatedTables,
  //       selectedConnectedFields: selectedItem.config.selectedConnectedFields.filter((field) =>
  //         updatedTables.some((table) => field.startsWith(table))
  //       ),
  //     },
  //   });
  // };

  // const handleFieldChange = (tableName: string, fieldName: string, isChecked: boolean) => {
  //   if (!selectedItem) return;
  //   const fullFieldName = `${tableName}.${fieldName}`;
  //   const isMainTable = tableName === selectedItem.config.selectedMainTable;
  //   const fieldList = isMainTable ? selectedItem.config.selectedFields : selectedItem.config.selectedConnectedFields;

  //   const updatedFields = isChecked
  //     ? [...fieldList, fullFieldName]
  //     : fieldList.filter((f) => f !== fullFieldName);

  //   setSelectedItem({
  //     ...selectedItem,
  //     config: {
  //       ...selectedItem.config,
  //       [isMainTable ? 'selectedFields' : 'selectedConnectedFields']: updatedFields,
  //     },
  //   });
  // };

  // --------------------- Filter Items ---------------------
  const filteredItems =
    activeBuilder === 'opcode'
      ? opCodes.filter((opcode) => opcode.name.toLowerCase().includes(searchTerm?.toLowerCase() || ''))
      : pages.filter((page) => page.title.toLowerCase().includes(searchTerm?.toLowerCase() || ''));

  // --------------------- Render Preview ---------------------
  // const renderPreview = () => {
  //   if (!selectedItem || !('dataType' in selectedItem)) return <div>No OpCode selected</div>;
  //   switch (selectedItem.dataType) {
  //     case 'table':
  //       return (
  //           <Card>
  //               <CardContent>
  //                   <Table>
  //                       <TableHead>
  //                           <TableRow>
  //                               {(selectedItem.config.selectedFields || []).map((field) => (
  //                                   <TableCell key={field}>{field.split('.')[1]}</TableCell>
  //                   ))}
  //                           </TableRow>
  //                       </TableHead>
  //                       <TableBody>
  //                           <TableRow>
  //                               {(selectedItem.config.selectedFields || []).map((field) => (
  //                                   <TableCell key={field}>Sample data</TableCell>
  //                   ))}
  //                           </TableRow>
  //                       </TableBody>
  //                   </Table>
  //               </CardContent>
  //           </Card>
  //       );
  //     case 'form':
  //       return (
  //           <Card>
  //               <CardContent>
  //                   <Form {...formMethods}>
  //                       <div className="space-y-4">
  //                           {(selectedItem.config.selectedFields || []).map((field) => (
  //                               <div key={field} className="space-y-2">
  //                                   <Label htmlFor={field}>{field.split('.')[1]}</Label>
  //                                   <Input id={field} placeholder={`Enter ${field.split('.')[1]}`} />
  //                               </div>
  //               ))}
  //                           <Button type="submit">Submit</Button>
  //                       </div>
  //                   </Form>
  //               </CardContent>
  //           </Card>
  //       );
  //     case 'chart':
  //       return (
  //           <Card>
  //               <CardContent>
  //                   <div className="h-[200px] flex items-center justify-center bg-muted">Chart preview placeholder</div>
  //               </CardContent>
  //           </Card>
  //       );
  //     default:
  //       return (
  //           <Card>
  //               <CardContent>
  //                   <p>Custom component preview</p>
  //               </CardContent>
  //           </Card>
  //       );
  //   }
  // };

  return (
      <div className="flex h-full w-full">
          <Sidebar
        activeBuilder={activeBuilder}
        setActiveBuilder={setActiveBuilder}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filteredItems={filteredItems}
        setSelectedItem={setSelectedItem}
        handleEditPage={handleEditPage}
        handleAddOpCode={handleAddOpCode}
        handleAddPage={handleAddPage}
        selectedItem={selectedItem}
      />
          <MainContent
        activeBuilder={activeBuilder}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        opCodes={opCodes}
        // pages={pages}
        setPages={setPages}
        handleSaveChanges={handleSaveChanges}
        handleSaveSchema={handleSaveSchema}
        assistantResponse={assistantResponse}
        setAssistantResponse={setAssistantResponse}
        jsonBlocks={jsonBlocks}
        setJsonBlocks={setJsonBlocks}
        showValidationErrors={showValidationErrors}
        isSaving={isSaving}
        generatePreviewPayload={generatePreviewPayload}
        previewBlocks={previewBlocks}
        setPreviewBlocks={setPreviewBlocks}
      />
          {showPageSettingsModal && newPage && (
          <PageSettingsModal
          isOpen={showPageSettingsModal}
          onClose={() => {
            setShowPageSettingsModal(false);
            setNewPage(null);
          }}
          onSave={(updatedPage) => {
            if (pages.some((p) => p.id === updatedPage.id)) {
              setPages((prev) => prev.map((p) => (p.id === updatedPage.id ? updatedPage : p)));
            } else {
              setPages((prev) => [...prev, updatedPage]);
            }
            setShowPageSettingsModal(false);
            setNewPage(null);
          }}
          page={newPage}
        />
      )}
      </div>
  );
}